import type { IOvertimeResult } from '../../../../models/overtime/OvertimeModel';

export type OvertimeFormValues = {
  startDate: string;
  endDate: string;
  description: string;
  status?: 'Pending' | 'Approved' | 'Rejected';
  rejectionReason?: string;
};

export const toDateTimeLocalValue = (date: Date | string | undefined): string => {
  if (!date) {
    return '';
  }

  const parsed = date instanceof Date ? date : new Date(date);
  if (isNaN(parsed.getTime())) {
    return '';
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  const hours = String(parsed.getHours()).padStart(2, '0');
  const minutes = String(parsed.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const getDefaultOvertimeFormValues = (): OvertimeFormValues => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  return {
    startDate: toDateTimeLocalValue(today),
    endDate: toDateTimeLocalValue(tomorrow),
    description: '',
  };
};

export const getEditOvertimeFormValues = (overtime: IOvertimeResult): OvertimeFormValues => {
  return {
    startDate: toDateTimeLocalValue(overtime.startDate),
    endDate: toDateTimeLocalValue(overtime.endDate),
    description: overtime.description ?? '',
    status: overtime.status,
    rejectionReason: overtime.rejectionReason ?? '',
  };
};

export const calculateTotalHoursFromStrings = (startDate: string, endDate: string): number => {
  if (!startDate || !endDate) {
    return 0;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return 0;
  }

  const diffInMs = end.getTime() - start.getTime();
  const diffInHours = diffInMs / (1000 * 60 * 60);
  return Math.round(diffInHours * 100) / 100;
};

export const parseFormDates = (values: OvertimeFormValues) => {
  return {
    startDate: new Date(values.startDate),
    endDate: new Date(values.endDate),
    totalHours: calculateTotalHoursFromStrings(values.startDate, values.endDate),
  };
};
